import { CourseSectionDetails } from '@buf/studyo_studyo-today-planners.bufbuild_es/studyo/today/planners/v1/resources/course_section_details_pb';
import { CourseSectionRole } from '@buf/studyo_studyo-today-planners.bufbuild_es/studyo/today/planners/v1/resources/course_section_role_pb';

export function getPlannerCourseSectionIsTaught(course: CourseSectionDetails): boolean {
  return course.role === CourseSectionRole.TEACHER && course.schoolsCourseSection != null;
}
